import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export default class Toggle extends Component {
  static propTypes = {
    open: PropTypes.bool,
    children: PropTypes.element
  };

  state = {
    toggling: false,
    opening: false,
    closing: false
  };

  componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.fadeIn();
    }

    if (this.props.open && !nextProps.open) {
      this.fadeOut();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.open && this.props.open) {
      this.setState({ opening: true });
    } else if (prevProps.open && !this.props.open) {
      this.setState({ closing: true });
    }
  }

  fadeIn() {
    this.setState({ toggling: true });
    setTimeout(() => {
      this.setState({ toggling: false, opening: false });
    }, 300);
  }

  fadeOut() {
    this.setState({ toggling: true });
    setTimeout(() => {
      this.setState({ toggling: false, closing: false });
    }, 300);
  }

  render() {
    const { open, children } = this.props;
    const { toggling, opening, closing } = this.state;

    const classes = classNames({
      collapse: !toggling,
      in: open && !toggling,
      collapsing: toggling
    });

    const styles = {};

    if (closing) {
      styles.height = "0px";
    } else if (opening || (toggling && !open)) {
      const { height } = this.childContainer.getBoundingClientRect();
      styles.height = `${height}px`;
    }

    return (
      <div className={classes} style={styles}>
        <div
          ref={node => {
            this.childContainer = node;
          }}
        >
          {(open || toggling) && children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/modules/shared/containers/Toggle.jsx